<!-- template for the modal component -->
<template type="x/template">
    <transition name="modal" id="banner-dialog">
        <div class="modal-mask" v-show="show">
            <div class="modal-container" @click.stop>
                <div class="modal-header">
                    <h3>{{ modalData.id ? 'Banner módosítása' : 'Új banner' }}</h3>
                </div>
                <div class="modal-body">
                    <div class="form-group row">
                        <div class="col-lg-12 col-sm-10 col-md-10">
                            <div class="row">
                                <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                                    <image-uploader :data="imageData"
                                                    @onImageLoaded="onImageLoaded"
                                                    @onImageRemoved="onImageRemoved
                                    "/>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                                    <label class="control-label">Név</label>
                                    <input type="text" class="form-control" v-model="modalData.title"
                                           :class="{ 'field-error' : this.$v.modalData.title.$error }"/>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                                    <label class="control-label">Link</label>
                                    <input type="text" class="form-control" v-model="modalData.url"/>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                                    <label class="control-label">Hól jelenjen meg a banner?</label>
                                    <b-form-select v-model="modalData.side" class="form-control" :options="side_list"></b-form-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer col-lg-12 col-sm-12 col-md-12 col-xs-12">
                        <div class="form-group row justify-content-center">
                            <div class="col-lg-6 col-sm-6 col-xs-6">
                                <button class="modal-default-button btn btn-secondary ml-3" @click="close()">Mégsem</button>
                            </div>
                            <div class="col-lg-6 col-sm-6 col-xs-6">
                                <button class="modal-default-button btn btn-primary ml-3" @click="save()">Kész</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { required } from 'vuelidate/lib/validators'
    import ImageUploader from "../../common/lib/fileUploader/ImageUploader";

    export default {
        name: 'banner-dialog',
        props: {
            show: {
                type: Boolean,
            },
            data: {
                type: Object,
            },
            method: {
                type: Function
            }
        },
        data: function () {
            return {
                side_list: [
                    { value: '', text: 'Inaktív'},
                    { value: 'top_90', text: 'Főoldal | fejléc (728x90)' },
                    { value: 'home_featured_230h', text: 'Főoldal | kiemelt (1150x230)' },
                    { value: 'home_category1_190', text: 'Főoldal | hirek után (728x190)' },
                    { value: 'home_category2_190', text: 'Főoldal | tech után (728x190)' },
                    { value: 'home_popular_370', text: 'Főoldal | legnépszerűbb után (370x370)' },

                    { value: 'top_90_post', text: 'Cikk | fejléc (728x90)' },
                    { value: 'right_370', text: 'Cikk | Jobb oldalt (370x370)' },
                    { value: 'right_600', text: 'Cikk| Jobb oldalt nagy (300x600)' },
                    { value: 'paragraph_190', text: 'Cikk | Az első bekezdés után (728x190)' },
                    { value: 'content_90', text: 'Cikk | Tartalom után (728x90)' },
                    { value: 'content_190', text: 'Cikk | Tartalom után (728x190)' },

                    { value: 'top_90_list', text: 'Rovat | fejléc (728x90)' },
                    { value: 'list_popular_370', text: 'Rovat | legnépszerűbb előtt (370x370)' },
                    { value: 'list_popular_600', text: 'Rovat | legnépszerűbb után (370x600)' },
                    { value: 'list_inside_1', text: 'Rovat| Cikkek közt 1 (728x190)' },
                    { value: 'list_inside_2', text: 'Rovat| Cikkek közt 2(728x190)' },
                ],
                image_removed: false,
            };
        },
        components: {
            ImageUploader,
        },
        computed: {
            imageData: {
                get: function() {
                    return {
                        image: this.modalData.banner_url,
                    }
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            modalData: {
                get: function() {
                    return this.data;
                },
                set: function(newVal) {
                    return newVal;
                }
            }
        },
        methods: {
            close: function () {
                this.$emit('close');
            },
            save: function () {
                this.$v.modalData.$touch();

                if(!this.$v.modalData.$invalid) {
                    if((!this.modalData.id && this.modalData.image) || (this.modalData.id && !this.image_removed)) {
                        this.$emit('onProcessed', this.modalData);
                        this.close();
                    } else {
                        this.$store.commit('setErrorMessage', 'Válassza ki a bannert (kép)!');
                    }

                } else {
                    this.$emit('onProcessError', this.modalData);
                    this.$store.commit('setErrorMessage', 'Töltse ki a mezőket!');
                }
            },
            onImageLoaded(imageObject) {
                this.$emit('onImageLoaded', imageObject);
                this.modalData.image = imageObject;
                this.image_removed = false;
            },
            onImageRemoved() {
                this.image_removed = true;
            }
        },
        mounted: function () {
            document.addEventListener("keydown", (e) => {
                if (this.show && e.keyCode == 27) {
                    this.close();
                }
            });
        },
        watch: {
            data: function(newVal) {
                this.modalData = newVal;
                this.$set(this.imageData, 'image', newVal.banner_url);
                this.$set(this.imageData, 'dimensions',{
                    width: newVal.width,
                    height: newVal.height
                } );

                if(this.modalData.method && this.modalData.id) {
                    this.modalData.method(this.modalData.id);
                }
            },
        },
        validations() {
            return {
                modalData: {
                    title: required,
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    * {
        box-sizing: border-box;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s ease;
    }

    .modal-container {
        width: 450px;
        margin: 40px auto 0;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 0px 0;
    }

    .text-right {
        text-align: right;
    }

    .form-label {
        display: block;
        margin-bottom: 1em;
    }

    .form-label > .form-control {
        margin-top: 0.5em;
    }

    .form-control {
        display: block;
        width: 100%;
        padding: 0.5em 1em;
        line-height: 1.5;
        border: 1px solid #ddd;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .hr {
        border-bottom: 1px #ededed solid;
    }

    .del {
        padding-top: 27px;
        font-size: 20px;
        cursor: pointer;
    }

    .items-holder {
        height: 250px;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>